import Swiper from "swiper";
import { A11y, Autoplay, EffectFade } from "swiper/modules";
import "@styles/components/slider.css";

const handlePanelScroll = () => {
  if (!window.matchMedia("(min-width: 1024px)").matches) {
    return;
  }
  document.querySelectorAll(".element-contentpanelscroller").forEach((el) => {
    const headerHeight = document.querySelector(".site-header").offsetHeight;

    el.querySelectorAll(".scroll-panel").forEach((panel) => {
      const id = panel.dataset.id;
      const rect = panel.getBoundingClientRect();
      const topOffset = rect.top - headerHeight;
      const media = el.querySelector(`.panel-media[data-id="${id}"]`);

      if (topOffset < 0) {
        media.style.transform = `translateY(${topOffset}px)`;
      } else {
        media.style.transform = `translateY(0)`;
      }
    });
  });
};

window.addEventListener("scroll", handlePanelScroll);
window.addEventListener("resize", handlePanelScroll);

handlePanelScroll();

document.querySelectorAll(".element-contentpanelscroller .panel-media-slider").forEach((el) => {
  const container = el.querySelector(".swiper");
  const numSlides = el.querySelectorAll(".swiper-slide").length;

  if (numSlides > 1) {
    const opts = {
      modules: [A11y, Autoplay, EffectFade],
      autoplay: {
        delay: 4000,
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      speed: 1000,
    };

    new Swiper(container, opts);
  }
});
